/**
 * Puig's "full scope" brand set for the Create Batch drawer (task 869f3cuzu).
 *
 * There is no datum behind this list: DIPI_CUSTOMER_BRAND only carries the
 * Visibility Tracker availability flags, not a mapping scope, so the set was
 * given by hand in the task and is hard-coded here "for now" (Daniel,
 * 2026-09-17). When the scope changes, this file is what has to change.
 *
 * The task listed 66 ids with 157 repeated; these are the 65 unique ones, in the
 * order they were given.
 */
export const PUIG_FULL_SCOPE_CUSTOMER_ID = 2

export const PUIG_FULL_SCOPE_BRAND_IDS = [
	5, 59, 561, 9, 10, 105, 14, 6, 29, 47,
	34, 1, 1421, 12, 18, 31, 15, 21, 71, 35,
	25, 41, 39, 28, 13, 54, 1678, 52, 1419, 169,
	143, 87, 157, 40, 117, 1477, 689, 53, 23, 687,
	4, 97, 130, 1427, 122, 42, 1583, 207, 1412, 1481,
	575, 598, 3, 1475, 7843, 46, 24, 317, 60, 696,
	20, 162, 1482, 1634, 8366
]
